/* ========================================
   Mock Data — MMG (Medico Medicina Generale)
   ======================================== */

export const mmgKPI = {
  pazientiInADI: 14,
  richiesteInAttesa: 2,
  dimissioniProtette: 1,
  alertAttivi: 3,
};

export const dimissioniProtette = [
  {
    id: 'dim-1',
    pazienteNome: 'Bianchi Mario',
    pazienteEta: 79,
    reparto: 'Geriatria — Ospedale San Giovanni',
    dataDimissione: '19/02/2026',
    diagnosi: 'Scompenso cardiaco acuto in BPCO riacutizzata',
    paiOspedaliero: true,
    letteraDimissione: true,
    urgenza: 'alta',
    note: 'Necessita O2 terapia domiciliare e monitoraggio parametri vitali.',
  },
];

export const notificheMMG = [
  {
    id: 'not-1',
    tipo: 'validazione',
    titolo: 'Bozza PAI pronta per la visione',
    descrizione: 'Il Case Manager ha completato la bozza del PAI per Rossi Anna. Richiesta la tua validazione clinica.',
    paziente: 'Rossi Anna',
    timestamp: '18/02/2026 09:15',
    letto: false,
    priorita: 'media',
  },
  {
    id: 'not-2',
    tipo: 'alert-clinico',
    titolo: 'Anomalia parametri da telemonitoraggio',
    descrizione: 'Rilevata SpO2 88% per il paziente Verdi Luca. Valore sotto soglia critica (min 92%). Ultimo rilevamento ore 08:30.',
    paziente: 'Verdi Luca',
    timestamp: '18/02/2026 08:45',
    letto: false,
    priorita: 'critica',
  },
  {
    id: 'not-3',
    tipo: 'amministrativo',
    titolo: 'Attivazione ADI completata',
    descrizione: 'Il percorso ADI per Neri Giuseppe e stato attivato con successo. Provider assegnato: Coop. Salute a Casa.',
    paziente: 'Neri Giuseppe',
    timestamp: '17/02/2026 16:30',
    letto: true,
    priorita: 'bassa',
  },
  {
    id: 'not-4',
    tipo: 'validazione',
    titolo: 'Rivalutazione PAI in scadenza',
    descrizione: 'Il PAI di Ferrara Elena (Cure Palliative) scade tra 10 giorni. Prevista rivalutazione UVMD.',
    paziente: 'Ferrara Elena',
    timestamp: '17/02/2026 10:00',
    letto: true,
    priorita: 'media',
  },
];

export const pazientiInCaricoMMG = [
  { id: 1, nome: 'Rossi Anna', eta: 76, diagnosi: 'BPCO con insufficienza respiratoria', cia: 'CIA-1', stato: 'attivo', provider: 'Coop. Cuore di San Camillo', ultimoAccesso: '18/02/2026', cf: 'RSSNNA50A70H501C', paiStato: 'validato' },
  { id: 2, nome: 'Verdi Luca', eta: 68, diagnosi: 'Ictus ischemico — riabilitazione', cia: 'CIA-3', stato: 'attivo', provider: 'Coop. Riabilita Roma', ultimoAccesso: '17/02/2026', cf: 'VRDLCU58D22H501B', paiStato: 'validato' },
  { id: 3, nome: 'Neri Giuseppe', eta: 82, diagnosi: 'Frattura femore — post-chirurgico', cia: 'CIA-2', stato: 'attivo', provider: 'ASL Roma 2 — Fisioterapia', ultimoAccesso: '18/02/2026', cf: 'NRIGPP44L17H501D', paiStato: 'da-validare' },
  { id: 4, nome: 'Ferrara Elena', eta: 72, diagnosi: 'Neoplasia mammaria metastatica', cia: 'CIA-4', stato: 'in-scadenza', provider: 'Fondazione Hospice Roma Sud', ultimoAccesso: '16/02/2026', cf: 'FRRLNE53H54H501Z', paiStato: 'validato' },
  { id: 5, nome: 'Esposito Luca', eta: 64, diagnosi: 'Insufficienza renale cronica IV', cia: 'CIA-3', stato: 'attivo', provider: 'Consorzio Salus', ultimoAccesso: '15/02/2026', cf: 'SPSLCU61M17H501D', paiStato: 'validato' },
  { id: 6, nome: 'Colombo Maria', eta: 88, diagnosi: 'Demenza senile avanzata', cia: 'CIA-4', stato: 'bozza', provider: null, ultimoAccesso: null, cf: 'CLMMRA38T41H501E', paiStato: 'bozza' },
  { id: 7, nome: 'Romano Pietro', eta: 71, diagnosi: 'Diabete con piede diabetico', cia: 'CIA-2', stato: 'attivo', provider: 'ASL Roma 2 — Inf. Territoriale', ultimoAccesso: '17/02/2026', cf: 'RMNPTR55B12H501F', paiStato: 'validato' },
];

/* Diario clinico per paziente (timeline eventi) */
export const diarioClinico = {
  1: [
    { id: 'd1-1', data: '18/02/2026 08:30', tipo: 'infermiere', titolo: 'Rilevazione Parametri Vitali', dettaglio: 'PA 130/80, FC 78, SpO2 91%, Temp 36.4. O2 terapia 2L/min in corso.', operatore: 'Inf. Colombo Sara' },
    { id: 'd1-2', data: '16/02/2026 09:00', tipo: 'infermiere', titolo: 'Somministrazione Terapia', dettaglio: 'Aerosol con Salbutamolo + Ipratropio bromuro. Paziente collaborante.', operatore: 'Inf. Colombo Sara' },
    { id: 'd1-3', data: '14/02/2026 10:15', tipo: 'fisioterapista', titolo: 'Riabilitazione Respiratoria', dettaglio: 'Esercizi espansione toracica, drenaggio posturale. Tolleranza discreta.', operatore: 'Ft. Galli Marco' },
    { id: 'd1-4', data: '12/02/2026 08:45', tipo: 'infermiere', titolo: 'Prelievo Ematico', dettaglio: 'Prelievo per emocromo, funzionalita renale, BNP. Campioni inviati.', operatore: 'Inf. Rossi Luca' },
    { id: 'd1-5', data: '10/02/2026 14:00', tipo: 'oss', titolo: 'Igiene e Mobilizzazione', dettaglio: 'Igiene al letto completa. Mobilizzazione passiva lato sinistro.', operatore: 'OSS Belli Anna' },
  ],
  3: [
    { id: 'd3-1', data: '18/02/2026 09:30', tipo: 'fisioterapista', titolo: 'FKT Post-Chirurgica', dettaglio: 'Carico parziale su deambulatore. ROM ginocchio dx: 75 gradi (+10). Buon progresso.', operatore: 'Ft. Marchetti Laura' },
    { id: 'd3-2', data: '17/02/2026 08:00', tipo: 'infermiere', titolo: 'Medicazione Ferita Chirurgica', dettaglio: 'Ferita in buona guarigione, margini accostati. Nessun segno di infezione.', operatore: 'Inf. Bianchi Marta' },
    { id: 'd3-3', data: '15/02/2026 10:00', tipo: 'oss', titolo: 'Igiene e Supporto ADL', dettaglio: 'Assistenza alla vestizione, igiene personale. Paziente parzialmente collaborante.', operatore: 'OSS Conti Fabio' },
    { id: 'd3-4', data: '13/02/2026 11:00', tipo: 'fisioterapista', titolo: 'Valutazione Equilibrio', dettaglio: 'Tinetti 14/28 (+2 vs precedente). Training trasferimenti letto-sedia.', operatore: 'Ft. Marchetti Laura' },
  ],
};

/* PAI in attesa di validazione MMG */
export const paiDaValidare = {
  3: {
    versione: 'V1.0',
    dataRedazione: '12/02/2026',
    redattore: 'CM Baldi Francesca',
    obiettivi: 'Recupero deambulazione autonoma con ausilio entro 45 giorni.',
    interventi: [
      { professionista: 'Fisioterapista', frequenza: '3 accessi/sett.', prestazione: 'Riabilitazione post-chirurgica, rinforzo muscolare, training equilibrio' },
      { professionista: 'Infermiere', frequenza: '1 accesso/sett.', prestazione: 'Medicazione ferita chirurgica, monitoraggio guarigione' },
      { professionista: 'OSS', frequenza: '3 accessi/sett.', prestazione: 'Igiene, supporto mobilizzazione, supervisione deambulazione' },
    ],
    durata: '45 giorni',
    note: 'Buona prognosi riabilitativa. Valutazione ambiente domiciliare completata.',
  },
};

/* ========================================
   PRESCRIZIONI RAPIDE
   ======================================== */
export const prescrizioniRapide = [
  {
    id: 'presc-1',
    paziente: 'Totti Marco',
    eta: 74,
    cf: 'TTTMRC52H15H501J',
    diagnosi: 'Ulcera venosa cronica gamba sinistra',
    complessita: 'bassa',
    tipologia: 'Infermieristica Domiciliare',
    prestazioni: ['Medicazione ulcera', 'Monitoraggio guarigione', 'Educazione caregiver'],
    frequenza: '3 accessi/settimana',
    durata: '30 giorni',
    provider: 'Coop. Cuore di San Camillo',
    stato: 'attivata',
    dataRichiesta: '10/02/2026',
    dataAttivazione: '12/02/2026',
    note: 'Caregiver presente e formato sulla gestione della medicazione.',
  },
  {
    id: 'presc-2',
    paziente: 'Galli Franca',
    eta: 81,
    cf: 'GLLFRC45D50H501K',
    diagnosi: 'Post-operatorio protesi anca — riabilitazione leggera',
    complessita: 'bassa',
    tipologia: 'Fisioterapia Domiciliare',
    prestazioni: ['Mobilizzazione attiva assistita', 'Esercizi deambulazione', 'Training scale'],
    frequenza: '2 accessi/settimana',
    durata: '21 giorni',
    provider: null,
    stato: 'in-attesa',
    dataRichiesta: '17/02/2026',
    dataAttivazione: null,
    note: 'Paziente autonoma nelle ADL di base. Vive con figlia.',
  },
  {
    id: 'presc-3',
    paziente: 'Santoro Angelo',
    eta: 69,
    cf: 'SNTANGL57M22H501L',
    diagnosi: 'Diabete tipo 2 scompensato — educazione terapeutica',
    complessita: 'bassa',
    tipologia: 'Infermieristica Domiciliare',
    prestazioni: ['Educazione autogestione insulina', 'Monitoraggio glicemico', 'Cura piede diabetico'],
    frequenza: '2 accessi/settimana',
    durata: '14 giorni',
    provider: 'ASL Roma 2 — Inf. Territoriale',
    stato: 'attivata',
    dataRichiesta: '05/02/2026',
    dataAttivazione: '07/02/2026',
    note: 'Paziente motivato ma con scarsa compliance precedente.',
  },
  {
    id: 'presc-4',
    paziente: 'De Luca Teresa',
    eta: 85,
    cf: 'DLCTRS41B55H501M',
    diagnosi: 'Ipertensione arteriosa non controllata',
    complessita: 'bassa',
    tipologia: 'Infermieristica Domiciliare',
    prestazioni: ['Monitoraggio PA domiciliare', 'Compliance terapeutica', 'Prelievi periodici'],
    frequenza: '2 accessi/settimana',
    durata: '14 giorni',
    provider: null,
    stato: 'rifiutata',
    dataRichiesta: '14/02/2026',
    dataAttivazione: null,
    note: 'Provider ha rifiutato per saturazione capacita. Riassegnare.',
    motivoRifiuto: 'Capacita erogativa saturata per il periodo richiesto.',
  },
  {
    id: 'presc-5',
    paziente: 'Mancini Bruno',
    eta: 77,
    cf: 'MNCBRN49C12H501N',
    diagnosi: 'BPCO lieve — monitoraggio post-dimissione',
    complessita: 'bassa',
    tipologia: 'Infermieristica Domiciliare',
    prestazioni: ['Rilevazione parametri vitali', 'Compliance O2 terapia'],
    frequenza: '1 accesso/settimana',
    durata: '21 giorni',
    provider: 'Consorzio Salus',
    stato: 'completata',
    dataRichiesta: '20/01/2026',
    dataAttivazione: '22/01/2026',
    dataChiusura: '12/02/2026',
    note: 'Percorso concluso regolarmente. Parametri stabili.',
  },
];

export const providerDisponibili = [
  { id: 'prov-1', nome: 'Coop. Cuore di San Camillo', specialita: ['Infermieristica', 'OSS'], disponibilita: 'Entro 48h', distanza: '2.3 km', rating: 4.7 },
  { id: 'prov-2', nome: 'ASL Roma 2 — Inf. Territoriale', specialita: ['Infermieristica', 'Prelievi'], disponibilita: 'Entro 72h', distanza: '4.1 km', rating: 4.5 },
  { id: 'prov-3', nome: 'Coop. Riabilita Roma', specialita: ['Fisioterapia', 'Logopedia'], disponibilita: 'Entro 48h', distanza: '3.7 km', rating: 4.8 },
  { id: 'prov-4', nome: 'Consorzio Salus', specialita: ['Infermieristica', 'OSS', 'Fisioterapia'], disponibilita: 'Entro 24h', distanza: '1.8 km', rating: 4.6 },
];

/* ========================================
   COMUNICAZIONI & TELEMEDICINA
   ======================================== */
export const threadsComunicazioni = [
  {
    id: 'thread-1',
    tipo: 'canale',
    titolo: 'Centrale Operativa COT',
    partecipanti: ['COT Op. Ferretti', 'Inf. Coord. Longo', 'CM Baldi Francesca'],
    ultimoMessaggio: 'Confermata presa in carico Colombo Maria. Attesa assegnazione provider.',
    timestamp: '18/02/2026 12:05',
    nonLetti: 3,
    avatar: 'CO',
    color: '#3B82F6',
  },
  {
    id: 'thread-2',
    tipo: 'equipe',
    titolo: 'CM Giulia Neri (Paz. Rossi)',
    partecipanti: ['CM Baldi Francesca', 'Inf. Colombo Sara', 'Ft. Galli Marco'],
    ultimoMessaggio: 'Aggiornamento parametri vitali: SpO2 risalita a 93%.',
    timestamp: '18/02/2026 11:20',
    nonLetti: 2,
    avatar: 'RA',
    color: '#06B6D4',
  },
  {
    id: 'thread-3',
    tipo: 'canale',
    titolo: 'Reparto Geriatria (Dimissioni)',
    partecipanti: ['Dr. Conti A.', 'Inf. Coord. Bassi', 'Ass. Sociale Ricci'],
    ultimoMessaggio: 'Bianchi Mario: dimissione confermata per il 19/02. Lettera pronta.',
    timestamp: '18/02/2026 10:00',
    nonLetti: 1,
    avatar: 'RG',
    color: '#EF4444',
  },
  {
    id: 'thread-4',
    tipo: 'diretto',
    titolo: 'CM Baldi Francesca',
    partecipanti: ['CM Baldi Francesca'],
    ultimoMessaggio: 'La bozza PAI per Neri Giuseppe e pronta. Puoi visionarla?',
    timestamp: '18/02/2026 09:45',
    nonLetti: 1,
    avatar: 'BF',
    color: '#8B5CF6',
  },
  {
    id: 'thread-5',
    tipo: 'equipe',
    titolo: 'Equipe ADI — Neri Giuseppe',
    partecipanti: ['CM Baldi Francesca', 'Ft. Marchetti Laura', 'OSS Conti Fabio'],
    ultimoMessaggio: 'ROM ginocchio migliorato: 75 gradi. Proseguiamo con il protocollo.',
    timestamp: '17/02/2026 10:30',
    nonLetti: 0,
    avatar: 'NG',
    color: '#F59E0B',
  },
  {
    id: 'thread-6',
    tipo: 'diretto',
    titolo: 'Segreteria ADI',
    partecipanti: ['Seg. Moretti Laura'],
    ultimoMessaggio: 'La richiesta per Colombo Maria e in fase di processamento.',
    timestamp: '16/02/2026 14:00',
    nonLetti: 0,
    avatar: 'SA',
    color: '#10B981',
  },
];

export const messaggiThread = {
  'thread-1': [
    { id: 'mc-1', autore: 'COT Op. Ferretti', ruolo: 'Operatore COT', testo: 'Segnalazione ricevuta da PO San Giovanni per dimissione protetta Colombo Maria, 88 anni. Demenza senile avanzata. Richiesta attivazione ADI urgente.', timestamp: '18/02/2026 09:00', mio: false },
    { id: 'mc-2', autore: 'Dr. Amato Luca', ruolo: 'MMG', testo: 'Confermo la presa in carico. La paziente e mia assistita. Necessita CIA-4 per gravita del quadro cognitivo. Allego relazione clinica.', timestamp: '18/02/2026 09:25', mio: true },
    { id: 'mc-3', autore: 'Inf. Coord. Longo', ruolo: 'Infermiere Coord.', testo: 'Ricevuto. Avvio procedura di triage. Assegno alla Segreteria per la compilazione formale.', timestamp: '18/02/2026 10:15', mio: false },
    { id: 'mc-4', autore: 'CM Baldi Francesca', ruolo: 'Case Manager', testo: 'Presa in carico dal mio lato. Procedo con valutazione ambiente domiciliare e contatto caregiver.', timestamp: '18/02/2026 11:40', mio: false },
    { id: 'mc-5', autore: 'COT Op. Ferretti', ruolo: 'Operatore COT', testo: 'Confermata presa in carico Colombo Maria. Attesa assegnazione provider.', timestamp: '18/02/2026 12:05', mio: false },
  ],
  'thread-2': [
    { id: 'm1-1', autore: 'Inf. Colombo Sara', ruolo: 'Infermiere', testo: 'Parametri ore 08:30 — PA 135/82, FC 76, SpO2 91%. Paziente riferisce lieve dispnea al risveglio.', timestamp: '18/02/2026 08:45', mio: false },
    { id: 'm1-2', autore: 'Dr. Amato Luca', ruolo: 'MMG', testo: 'Grazie Sara. Manteniamo O2 a 2L/min. Se SpO2 scende sotto 90% contattarmi immediatamente.', timestamp: '18/02/2026 09:10', mio: true },
    { id: 'm1-3', autore: 'Ft. Galli Marco', ruolo: 'Fisioterapista', testo: 'Sessione riabilitativa ore 10:00. Tolleranza allo sforzo leggermente migliorata rispetto a lunedi.', timestamp: '18/02/2026 10:40', mio: false },
    { id: 'm1-4', autore: 'Inf. Colombo Sara', ruolo: 'Infermiere', testo: 'Aggiornamento parametri vitali: SpO2 risalita a 93%.', timestamp: '18/02/2026 11:20', mio: false },
  ],
  'thread-3': [
    { id: 'mg-1', autore: 'Dr. Conti A.', ruolo: 'Geriatra', testo: 'Bianchi Mario stabile dal punto di vista emodinamico. Prevediamo dimissione il 19/02. Serve attivazione ADI con O2 terapia.', timestamp: '17/02/2026 14:00', mio: false },
    { id: 'mg-2', autore: 'Dr. Amato Luca', ruolo: 'MMG', testo: 'Ricevuto. Ho gia compilato il Modello 431. Confermo la necessita di infermiere domiciliare + OSS. Avete preparato la lettera di dimissione?', timestamp: '17/02/2026 15:30', mio: true },
    { id: 'mg-3', autore: 'Inf. Coord. Bassi', ruolo: 'Infermiere Coord.', testo: 'Lettera di dimissione in fase di redazione. Sara pronta domani mattina.', timestamp: '17/02/2026 16:45', mio: false },
    { id: 'mg-4', autore: 'Dr. Conti A.', ruolo: 'Geriatra', testo: 'Bianchi Mario: dimissione confermata per il 19/02. Lettera pronta.', timestamp: '18/02/2026 10:00', mio: false },
  ],
  'thread-4': [
    { id: 'm2-1', autore: 'CM Baldi Francesca', ruolo: 'Case Manager', testo: 'Buongiorno Dottore. Ho completato la bozza del PAI per Neri Giuseppe. Prevede FKT 3/sett + Inf. 1/sett + OSS 3/sett per 45gg.', timestamp: '18/02/2026 09:30', mio: false },
    { id: 'm2-2', autore: 'CM Baldi Francesca', ruolo: 'Case Manager', testo: 'La bozza PAI per Neri Giuseppe e pronta. Puoi visionarla?', timestamp: '18/02/2026 09:45', mio: false },
  ],
  'thread-5': [
    { id: 'm5-1', autore: 'Ft. Marchetti Laura', ruolo: 'Fisioterapista', testo: 'FKT post-chirurgica: carico parziale su deambulatore. ROM ginocchio dx 65 gradi.', timestamp: '15/02/2026 11:00', mio: false },
    { id: 'm5-2', autore: 'Dr. Amato Luca', ruolo: 'MMG', testo: 'Ottimo. Continuiamo con il piano attuale. Rivalutazione tra una settimana.', timestamp: '15/02/2026 14:20', mio: true },
    { id: 'm5-3', autore: 'Ft. Marchetti Laura', ruolo: 'Fisioterapista', testo: 'ROM ginocchio migliorato: 75 gradi. Proseguiamo con il protocollo.', timestamp: '17/02/2026 10:30', mio: false },
  ],
  'thread-6': [
    { id: 'm6-1', autore: 'Seg. Moretti Laura', ruolo: 'Segreteria', testo: 'Buongiorno, la informo che la richiesta ADI per Colombo Maria e stata registrata. Numero protocollo: ADI-2026-0088.', timestamp: '16/02/2026 11:00', mio: false },
    { id: 'm6-2', autore: 'Dr. Amato Luca', ruolo: 'MMG', testo: 'Grazie. La paziente necessita di valutazione urgente. Prego di dare priorita.', timestamp: '16/02/2026 11:30', mio: true },
    { id: 'm6-3', autore: 'Seg. Moretti Laura', ruolo: 'Segreteria', testo: 'La richiesta per Colombo Maria e in fase di processamento.', timestamp: '16/02/2026 14:00', mio: false },
  ],
};

export const teleconsultiProgrammati = [
  { id: 'tc-1', specialista: 'Dr. Marini Roberto', specialita: 'Cardiologia', data: '21/02/2026', ora: '14:30', paziente: 'Rossi Anna', motivo: 'Rivalutazione terapia diuretica per scompenso cardiaco', stato: 'confermato' },
  { id: 'tc-2', specialista: 'Dr.ssa Ferraro Giulia', specialita: 'Pneumologia', data: '24/02/2026', ora: '10:00', paziente: 'Esposito Luca', motivo: 'Consulto su insufficienza respiratoria progressiva', stato: 'da-confermare' },
  { id: 'tc-3', specialista: 'Dr. Conti Alessandro', specialita: 'Geriatria', data: '19/02/2026', ora: '09:00', paziente: 'Bianchi Mario', motivo: 'Allineamento per dimissione protetta e piano terapeutico domiciliare', stato: 'confermato' },
];

/* ========================================
   FASCICOLO SANITARIO ELETTRONICO (FSE)
   ======================================== */
export const documentiFSE = {
  1: [
    { id: 'doc-1-1', tipo: 'referto', titolo: 'Spirometria', data: '15/02/2026', struttura: 'Ambulatorio Pneumologia — ASL Roma 2', contenuto: 'FEV1 45% pred. FVC 62% pred. Indice di Tiffeneau 58%. Ostruzione moderata-severa.', medico: 'Dr. Bianchi F.' },
    { id: 'doc-1-2', tipo: 'referto', titolo: 'Emocromo + BNP', data: '12/02/2026', struttura: 'Laboratorio Analisi — PO San Giovanni', contenuto: 'Hb 12.8, WBC 7200, PLT 245k. BNP 380 pg/mL (elevato). Creatinina 1.1.', medico: 'Lab.' },
    { id: 'doc-1-3', tipo: 'lettera-dimissione', titolo: 'Lettera Dimissione Geriatria', data: '02/02/2026', struttura: 'UOC Geriatria — PO San Giovanni', contenuto: 'Ricovero per riacutizzazione BPCO su scompenso cardiaco. Dimissione con O2 terapia 2L/min, diuretico ev.', medico: 'Dr. Rossi M.' },
    { id: 'doc-1-4', tipo: 'prescrizione', titolo: 'Prescrizione O2 Domiciliare', data: '03/02/2026', struttura: 'MMG — Dr. Amato Luca', contenuto: 'Ossigenoterapia a lungo termine 2L/min 16h/die. Controllo SpO2 quotidiano.', medico: 'Dr. Amato L.' },
    { id: 'doc-1-5', tipo: 'certificato', titolo: 'Certificato Invalidita Civile', data: '10/01/2026', struttura: 'Commissione Medica ASL Roma 2', contenuto: 'Riconosciuta invalidita civile 80%. Diritto indennita accompagnamento.', medico: 'Comm. Medica' },
    { id: 'doc-1-6', tipo: 'pai', titolo: 'PAI — Piano Assistenziale V1.2', data: '08/02/2026', struttura: 'UVM ADI — ASL Roma 2', contenuto: 'Infermiere 3/sett, FT 2/sett, OSS 2/sett. Obiettivo: stabilizzazione respiratoria.', medico: 'CM Baldi F.' },
  ],
  2: [
    { id: 'doc-2-1', tipo: 'referto', titolo: 'RMN Encefalo', data: '10/02/2026', struttura: 'Radiologia — PO Pertini', contenuto: 'Esiti ischemici nel territorio della MCA sinistra. Nessuna nuova lesione acuta.', medico: 'Dr. Conti A.' },
    { id: 'doc-2-2', tipo: 'referto', titolo: 'Ecocolordoppler TSA', data: '05/02/2026', struttura: 'Ambulatorio Angiologia', contenuto: 'Stenosi carotide interna sn 40%. Placca fibrolipidica stabile.', medico: 'Dr. Neri P.' },
    { id: 'doc-2-3', tipo: 'prescrizione', titolo: 'Terapia Antiaggregante', data: '12/02/2026', struttura: 'MMG — Dr. Amato Luca', contenuto: 'ASA 100mg/die + Atorvastatina 40mg/die. Controllo lipidico a 3 mesi.', medico: 'Dr. Amato L.' },
  ],
  3: [
    { id: 'doc-3-1', tipo: 'referto', titolo: 'RX Femore DX', data: '08/02/2026', struttura: 'Radiologia — PO S. Eugenio', contenuto: 'Protesi femore dx in sede. Consolidamento osseo in corso. Callo osseo visibile.', medico: 'Dr. Villa G.' },
    { id: 'doc-3-2', tipo: 'lettera-dimissione', titolo: 'Dimissione Ortopedia', data: '01/02/2026', struttura: 'UOC Ortopedia — PO S. Eugenio', contenuto: 'Osteosintesi femore dx. Carico parziale con deambulatore. FKT domiciliare raccomandata.', medico: 'Dr. Bassi R.' },
  ],
  7: [
    { id: 'doc-7-1', tipo: 'referto', titolo: 'Emoglobina Glicata', data: '14/02/2026', struttura: 'Laboratorio — ASL Roma 2', contenuto: 'HbA1c 8.2% (target <7%). Glicemia a digiuno 165 mg/dL.', medico: 'Lab.' },
    { id: 'doc-7-2', tipo: 'referto', titolo: 'Valutazione Piede Diabetico', data: '10/02/2026', struttura: 'Ambulatorio Diabetologia', contenuto: 'Ulcera neuropatica tallone dx Wagner 2. Sensibilita ridotta. Polsi periferici presenti.', medico: 'Dr.ssa Longo S.' },
  ],
};
